import React from 'react';
import './button.css';

const Button = () => {
  const handleContactClick = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <a href="/" className="custom-button" onClick={handleContactClick}>
      Contact Us
    </a>
  );
};

export default Button;
